import { useLocation } from '@/hooks/useLocation';
import { pathToAction } from 'redux-first-router';
import routesGenerator from '@/router/routesGenerator';
import queryString from 'query-string';
import { useMemo } from 'react';
import { isSupportedLocale } from '@/utils/locale';

/**
 * Gets the current locale language value.
 */
export const useLocale = () => {
  const location = useLocation();

  const locale = useMemo(() => {
    // Reconstruct the current redux router action from the current path.
    // This implicitly parses the params, so the current locale specified in route can be used.
    const action = pathToAction(
      location.pathname,
      routesGenerator(),
      queryString
    );

    if (isSupportedLocale(action.payload?.locale)) {
      return action.payload?.locale;
    }

    return 'en';
  }, [location.pathname]);

  return locale;
};

export type Locale = ReturnType<typeof useLocale>;
